module.exports = __webpack_public_path__ + "danger.f6dc099240cc766d0ba0.svg";


//////////////////
// WEBPACK FOOTER
// C:/WORK/ZENN/mcr-contabilidade-fileshare/Application/ApplicationUI/src/assets/images/icon/danger.svg
// module id = ../../../../../src/assets/images/icon/danger.svg
// module chunks = styles